import api from './api';

const projectsUrl = '/api/v1/projects';

export default {
  count: async (
    projectId: string,
    filters?: {
      search: string;
    }
  ): Promise<any> =>
    api.get(`${projectsUrl}/${projectId}/configurations/count`, filters),
  delete: async (configurationId: string): Promise<any> =>
    api.delete(`/api/v1/configurations/${configurationId}`),
  get: async (configurationId: string): Promise<any> =>
    api.get(`/api/v1/configurations/${configurationId}`),
  getAll: async (
    projectId: string,
    filters: {
      limit?: number;
      offset?: number;
      search?: string;
    }
  ): Promise<any> =>
    api.get(`${projectsUrl}/${projectId}/configurations`, filters),
  post: async (config: any, projectId: string): Promise<any> =>
    api.post(`${projectsUrl}/${projectId}/configurations`, config),
  put: async (config: any, configurationId: string): Promise<any> =>
    api.put(`/api/v1/configurations/${configurationId}`, config),
};
